import HomeController from './home.controller';

const HomeComponent = {
	templateUrl: 'components/home/home.html',
	controller: HomeController,
	bindings: {
		$router: '<'
	}
};

export default HomeComponent;
